import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as componentTypes from "../../../../constants/componentTypes";
import * as navigationActions from "../../../../actions/navigationActions";
import * as actions from "../../../../actions/statisticsTabActions";
import * as modelHelper from "../../../../helpers/modelHelper";

import imgSave from "../../../../resources/img/svgicons/save.svg";
import Modal from "../../../global/generic/Modal";
import CancelButton from "../../../global/generic/CancelButton";
import Button from "../../../global/generic/Button";

class EditStatsNoteModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            note: this.props.params.note ? this.props.params.note : ""
        };
    }
    handleCloseModalClick = () => {
        this.props.dispatchCloseNoteModalAction();
    };

    handleSaveNoteClick = () => {
        this.props.dispatchSaveNoteAction(this.props.tabId, this.props.statsId, this.state.note);
        this.props.dispatchCloseNoteModalAction();
    };

    handleEditNoteChange = (event) => {
        this.setState({note: event.target.value});
    };

    getContent = () => {
        return this.props.statsId === null
            ? null
            : modelHelper.buildModalSection(
                  <textarea
                      className="col-12 min-height-20vh"
                      value={this.state.note}
                      onChange={this.handleEditNoteChange}
                  />
              );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                {this.props.statsId === null ? null : (
                    <Button label={translate("general.save")} onClick={this.handleSaveNoteClick} svgBefore={imgSave} />
                )}
                <CancelButton onClick={this.handleCloseModalClick} />
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="mainTab.editNote" />)}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{minWidth: "50%"}}
            />
        );
    }
}

const mapStoreToProps = (store, ownProps) => {
    if (ownProps.tabId === undefined || store.formula[ownProps.tabId] === undefined) {
        return {
            statsId: null
        };
    }

    return {
        statsId: store.formula[ownProps.tabId].statisticsId
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseNoteModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.EDIT_STATS_NOTE_MODAL));
        },
        dispatchSaveNoteAction: (tabId, statsId, note) => {
            dispatch(actions.saveStatisticNote(tabId, statsId, note));
        }
    };
};

export default EditStatsNoteModal = connect(mapStoreToProps, mapDispatchToProps)(EditStatsNoteModal);
